// Canonical cross-repo commerce read policy (REST specs/00 §9.3.1;
// Admin specs/01 §3.1.1). This positive allowlist is presentation-only;
// REST performs the authoritative live-DB role check on every request.

export const COMMERCE_POLICY_ID = 'commerce-rbac-v1' as const;

export const COMMERCE_CAPABILITIES = {
  planCatalogRead: 'plan-catalog:read',
  planGrantRead: 'plan-grant:read',
  commerceRead: 'commerce:read',
} as const;

export type CommerceCapability = (typeof COMMERCE_CAPABILITIES)[keyof typeof COMMERCE_CAPABILITIES];

const FULL_READ_ROLES = new Set(['platform-owner', 'admin', 'security-officer']);
const KNOWN_CAPABILITIES = new Set<CommerceCapability>(Object.values(COMMERCE_CAPABILITIES));

export function hasCommerceCapability(role: string | null | undefined, capability: CommerceCapability): boolean {
  // Route/navigation metadata is runtime data even when TypeScript callers are
  // typed. Validate the key before the full-admin shortcut so unknown keys are
  // never converted into an implicit allow.
  if (!role || !KNOWN_CAPABILITIES.has(capability)) return false;
  if (FULL_READ_ROLES.has(role)) return true;
  // plan-grant:read intentionally excluded (spec §5 07-30 裁決): the server's
  // requireAccountingRead 403s cs-readonly, so granting the nav/page here only
  // produced a broken page.
  return role === 'cs-readonly' && capability === COMMERCE_CAPABILITIES.planCatalogRead;
}
